// extracted by mini-css-extract-plugin
export default {"swiper":"WorkItemSwiper_swiper__tuJym","swiper-slide":"WorkItemSwiper_swiper-slide__khzbQ"};